<template>
  <div class="jobs">

    <Hero
      :title="bannerProps.title"
      :image="bannerProps.banner"
      :searchBox="true"
      layout="md"
      class="darker"
    />

    <Brands />

    <div class="row">
      <div class="col-11 col-lg-9 mx-auto">
        <Jobs :key="$route.fullPath" />
      </div>
    </div>

  </div>
</template>

<script>
import Hero from "@/components/media/Hero.vue";
import Jobs from "@/components/jobs/Jobs.vue";
import Brands from "@/views/home/components/Brands.vue";

export default {
  name: "JobsList",

  data() {
    return {
    }
  },

  computed: {
    bannerProps(){
      const team = this.$store.state.teams.find((team) => team.slug == this.$route.query.collection)

      if(team){
        return {
          title: `<strong>Vagas ${team.title}</strong><br/>Assim é a <strong>InBrands</strong>`,
          banner: team.coverImage
        }
      } else {
        return {
          title: `<strong>Vagas</strong><br/>Assim é a <strong>InBrands</strong>`,
          banner: "banner-escritorio.jpeg"
        }
      }

    }
  },

  components: {
    Hero,
    Jobs,
    Brands
  },
};
</script>

<style lang="scss" scoped>
  .jobs{
    padding-top: 60px;
  }
</style>